export const MAIN_SECTION = 'main';

export const DETAILS_SECTION = 'details';

export const SALES_INVOICE_LIST_EXPORT_ID = 'sales-invoice-list';
export const SALES_INVOICE_LIST_TITLE = 'Listado de facturas';

export const MAIN_SECTION_LOCALIZED_PROPERTIES = {
  trip: 'Viaje',
  status: 'Estado',
  statusERP: 'Estado ERP',
  route: 'Ruta',
  user: 'Usuario',
  responsible: 'Responsable',
  responsibleCode:' Cod. Responsable',
  clientCode: 'Cod. Cliente',
  client: 'Cliente',
  NIT: 'NIT',  
  serial: 'Nro. Doc.',
  serialExternal: 'Nro. Doc. Externo',
  classCode: 'Cod. Clase',
  class: 'Clase',
  createDateTimeDate: 'Fecha de Creación',
  createDateTimeHour: 'Hora de Creación',
  updateAuditAtDate: 'Fecha de Modificación',
  updateAuditAtHour: 'Hora de Modificación',
  updatedByUser: 'Usuario de Modificación',
  destinationCode: 'Cod. Destinatario',
  destination: 'Destinatario',
  address: 'Dirección',
  expeditionCondition: 'Clase de Expedición',
  paymentConditionCode:' Cod. Condición de Pago',
  paymentCondition: 'Condición de Pago',
  note: 'Nota',
  loadDateTime: 'Fecha de Carga',
  deliveryDateTime: 'Fecha de Entrega',
  extraStatusERPGlobal: 'Estado Global',
  extraStatusERPReject: 'Estado de rechazo',
  extraStatusERPDelivery: 'Estado de entrega',
  extraStatusERPCredit: 'Estado de crédito',
  extraStatusERPInvoice: 'Estado de factura',
  extraStatusERPUser: 'Estado de usuario',
  subtotal: 'Subtotal',
  totalSurcharges: 'Recargo',
  totalDiscounts: 'Descuento',
  totalTaxes: 'Impuesto',
  total: 'Total',
};

export const DETAILS_SECTION_LOCALIZED_PROPERTIES = {
  serial: 'Nro. Doc.',
  serialCodeExt: 'Nro. Doc. Externo',
  sourceDocument: 'Nro. Doc. Origen',
  nextDocument: 'Nro. Doc. Destino',
  trip: 'Viaje',
  materialCode: 'Cod. Material',
  material: 'Material',
  note: 'Nota',
  warehouse: 'Almacén',
  soldQuantity: 'Cantidad (UM)',
  stockConfirmedERP: 'Cant. Confirmada',
  externalQuantity: 'Cant. Entregada',
  externalDocument: '# Doc. Entrega',
  externalPrice: 'Precio Facturado',
  externalDiscount: 'Desc. Factura',
  invoice: '# Factura',
  price: 'Precio',
  subtotal: 'SubTotal',
  totalSurcharges: 'Recargo',
  totalDiscounts: 'Descuento',
  totalTaxes: 'Impuesto',
  total: 'Total',
};
